import { Typography, type TypographyProps } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useTitleStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
  },
}));

export const SectionTitle = ({
  children,
  classes: classesOverride,
  ...rest
}: Omit<TypographyProps, "ref">) => {
  const classes = useTitleStyles();

  return (
    <Typography
      variant="h3"
      component="h2"
      {...rest}
      classes={{ ...classes, ...classesOverride }}
    >
      {children}
    </Typography>
  );
};

const useSubtitleStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    marginTop: `-${theme.spacing()}px`,
  },
}));

export const SectionSubtitle = ({
  children,
  classes: classesOverride,
  ...rest
}: Omit<TypographyProps, "ref">) => {
  const classes = useSubtitleStyles();

  return (
    <Typography
      variant="subtitle1"
      component="h3"
      {...rest}
      classes={{ ...classes, ...classesOverride }}
    >
      {children}
    </Typography>
  );
};
